import React from 'react'

const JobCircular_list = () => {
    return (
        <div>JobCircular_list</div>
    )
}

export default JobCircular_list


// WEBPACK FOOTER //
// ./src/component/admin/job/JobCircular_list.js